Pluswerk.PlusProject.CountDownPlugin = Pluswerk.PlusProject.CountDownPlugin || {};
Pluswerk.PlusProject.CountDownPlugin.CountDownPluginController = function () {
  // Set the date we're counting down to
  if ($('#countDownDate').length) {
    var s = $('#countDownDate').data('date').replace(/ /g, 'T');
    var formatDate = $('#countDownDate').data('dateformat');

    var a = s.split(/[^0-9]/);
    var endDate = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
    if (endDate) {
      calculateCountdown(endDate);

      // Update the count down every 1 second
      var x = setInterval(function () {
        calculateCountdown(endDate);
      }, 1000);
    }
  }

  function calculateCountdown(endDate) {
    var countDownDate = new Date(endDate).getTime();

    // Get todays date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    var digits = ('' + days).split('');
    var d = '';
    for (var index = 0; index < digits.length; ++index) {
      d = d + '<span id="timeleft">' + digits[index] + '</span>';
    }
    var hour = ('' + hours).split('');
    var h = '';
    for (index = 0; index < hour.length; ++index) {
      h = h + '<span id="timeleft">' + hour[index] + '</span>';
    }
    var min = ('' + minutes).split('');
    var m = '';
    for (index = 0; index < min.length; ++index) {
      m = m + '<span id="timeleft">' + min[index] + '</span>';
    }
    var sec = ('' + seconds).split('');
    var s = '';
    for (index = 0; index < sec.length; ++index) {
      s = s + '<span id="timeleft">' + sec[index] + '</span>';
    }

    if (distance > 0) {
      $('#days').html(d);
      $('#hours').html(h);
      $('#minutes').html(m);
      if (formatDate == '0') {
        $('#seconds').html(s);
      }
    }

    if ($('#countDownDate').is(':hidden')) {
      $('#countDownDate').css('display', 'block');
    }
    if ($('.teaserBox__textCountDown').is(':hidden')) {
      $('.teaserBox__textCountDown').css('display', 'inline-block');
    }

    // If the count down is over, write 00 00:00:00
    if (distance <= 0) {
      clearInterval(x);
      $('#days').html('0');
      $('#hours').html('0');
      $('#minutes').html('0');
      if (formatDate == '0') {
        $('#seconds').html('0');
      }
    }
  }

  var days = $('#days');
  var hours = $('#hours');
  var minutes = $('#minutes');
  var days_text = days.children('span').text();
  var hours_text = hours.children('span').text();
  var minutes_text = minutes.children('span').text();
  if (formatDate == '0') {
    var seconds = $('#seconds');
    var seconds_text = seconds.children('span').text();
  }
  if ((minutes_text <= 0) && (hours_text <= 0) && (days_text <= 0)) {
    if (formatDate == '0') {
      if (seconds_text <= 0) {
        $('.teaserBox__countDown-wrap').remove();
      }
    } else {
      $('.teaserBox__countDown-wrap').remove();
    }
  }
};
